import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import hashTable from "./hashTable"

const storageSize = 200

let defaultPalette: []

const paletteEngine = {
    hashTable: new hashTable(storageSize),
    setDefaultPalette: (palette: Array<DynamicFormPaletteTypes>) => {
        defaultPalette = JSON.parse(JSON.stringify(palette))
    },
    /* Returning the hexCode of the item in the hashTable. */
    getPaletteColor: (key: string) => {
        const paletteItem = paletteEngine.hashTable.lookupItem(key)
        return paletteItem ? paletteItem[2].hexCode : ""
    },
    /* Building a hash table. */
    buildHashTable: (palette: Array<DynamicFormPaletteTypes>) => {
        paletteEngine.setDefaultPalette(palette)
        for (let i = 0; i < palette.length; i++) {
            const item = palette[i]
            paletteEngine.hashTable.addItem([item.key, paletteEngine.hashTable.hash(item.key, storageSize), item])
        }
    },
    reducePalette: (palette: Array<DynamicFormPaletteTypes>) => {
        let reducedPalette = []
        for (let i = 0; i < defaultPalette.length; i++) {
            const a = palette[i].hexCode
            //@ts-ignore
            const b = defaultPalette[i].hexCode
            if (a !== b) {
                reducedPalette.push({ key: palette[i].key, hexCode: palette[i].hexCode })
            }
        }
        return reducedPalette.length > 0 ? reducedPalette : []
    }
}

export default paletteEngine